import moment from 'moment'
import { globalConfig } from '@/config'

moment.locale(globalConfig.lang)
